import {apiRequest} from "./apiRequest";
import type {GlobalFeatureFlags, SelfSignupDefaults} from "../types/configuration";

export async function getGlobalFeatureFlags(): Promise<GlobalFeatureFlags> {
  return apiRequest<GlobalFeatureFlags>({path: "admin/configuration/global"});
}

export async function updateGlobalFeatureFlags(
  flags: GlobalFeatureFlags,
): Promise<GlobalFeatureFlags> {
  return apiRequest<GlobalFeatureFlags>({
    path: "admin/configuration/global",
    method: "PUT",
    body: flags,
  });
}

export async function getSelfSignupDefaults(): Promise<SelfSignupDefaults> {
  return apiRequest<SelfSignupDefaults>({path: "admin/configuration/self-signup-defaults"});
}

export async function updateSelfSignupDefaults(
  defaults: SelfSignupDefaults,
): Promise<SelfSignupDefaults> {
  return apiRequest<SelfSignupDefaults>({
    path: "admin/configuration/self-signup-defaults",
    method: "PUT",
    body: defaults,
  });
}
